import { createContext, useContext } from 'react';

import { useWorkspacesList } from '../hooks';

const WorkspacesContext = createContext(null);

export const WorkspacesProvider = ({ children }) => {
  const value = useWorkspacesList();
  return <WorkspacesContext.Provider value={value}>{children}</WorkspacesContext.Provider>;
};

export const useWorkspaces = () => {
  const ctx = useContext(WorkspacesContext);
  if (!ctx) throw new Error('useWorkspaces must be used inside WorkspacesProvider');
  return ctx;
};
